import truncate from "lodash/truncate";

import { Box } from "@/storybook-components";
import { stripAllHtml } from "@/lib";
import type { Project } from "@/types";
import Item from "@/theme/components/item";
import { useAppSelector } from "@/redux/store/hooks";

const MAX_LENGTH = 214;

const ProjectDescription = ({ project }: { project: Project }): JSX.Element => {
  const { queryFilter } = useAppSelector((state) => state.projectFinder);
  const { projectDescLength } = queryFilter;

  const { metaDescription, description } = project;
  const data = metaDescription || description;
  const maxProjectDescLength = data?.length || 0;

  const excerpt = data
    ? truncate(stripAllHtml(data), {
        length: Math.min(maxProjectDescLength, projectDescLength || MAX_LENGTH)
      })
    : null;

  return (
    <Item className="ehq-cardItem">
      <Box
        as="p"
        className="ehq-projectDescriptionContainer"
        dangerouslySetInnerHTML={{ __html: excerpt }}
      />
    </Item>
  );
};

export default ProjectDescription;
